/******************************************************************
* @NAME y.xiang
* @CREATEDATE 2022/3/9
* @DESC <>
* ****************************************************************/
<template>
  <div class="utm-control-group">
    <label class="utm-control-label must-fill " :style="{'width':labelWidth}" v-if="!noShowLabel" :class="{'is-top':isTop}">Location</label>
    <div class="utm-controls" :class="{'is-top-conntorl':isTop}" :style="{'margin-bottom':marginBottom,'width':InputWidth, 'margin-left':labelWidth}"><!--:style="{'margin-left':labelWidth}"-->
      <!--存在默认的node-->
      <Select :disabled="isDisabled"
              v-model="objInfo.targetNodeId"
              filterable filter-by-label label-in-value
              class="utm-select"
              placeholder="Please select location" @on-change="changeNode">
        <template v-for="(node,index) in nodesList">
          <!-- 选DCS的节点需过滤没有开启DCS配置的节点 -->
          <template v-if="(!dcsMode || ApiService.disabledDCSNodeIds.indexOf(node.id) === -1) && disNodeIds.indexOf(node.id) === -1">
            <Option :key="index" :value="node.id" :label="node.name" v-show="!node.disabled">
            </Option>
          </template>
        </template>
      </Select>
      <span v-show="locationFlag" class="utm-is-danger">Please select location</span>
    </div>
  </div>
</template>

<script>
 /*************
  * 选择节点规则,当系统节点选项为All的时候才需要显示节点，如果已经选择了显示的节点，则默认为该节点；
  * 当默认节点后，不可自行更改节点，但需要显示该默认节点；
  * 修改数据时不可以更换节点
  * ****************/
export default {
  name: "utmSelectNode",
  props:{
    // 选DCS需判断是否对应的节点开启
    dcsMode:{
      type: Boolean,
      default: false
    },
    //  选DCS需过滤已经配置的节点
    disNodeIds:{
      type: Array,
      default:() => {
        return [];
     },
    },
    /*标题右对齐需要的宽度*/
    labelWidth:{
      type: String,
      default: ''
    },
    /*需要保存数据的对象*/
    objInfo:{
      type:Object,
      default:() => {
        return {
          targetNodeId:''
        }
     },
    },
    /*是否是修改界面*/
    isEdit: {
      type: Boolean,
      default: false
    },
    //是否提示location是否选择了
    locationFlag:{
      type:Boolean,
      default:false
    },
    marginBottom:{
      type:String
    },
    InputWidth:{
      type:String
    },
    //附加的节点，比如用户在某些情况下需要看到其他节点的用户，需要保证Location显示正常，需要去重，避免节点重复
    additionalNode:{
      type: Array,
      default:() => {
        return [];
     },
    },
    //判断节点name显示隐藏
    isHideName:{
      type:Boolean,
      default:true
    },
    isTop:{
      type:Boolean,
      default:false
    },
    noShowLabel:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      isDisabled:false,
      getHandleNodes:[],
      nodesList:[]
    }
  },
  watch: {
    'additionalNode':function(newValue){
      if(newValue && newValue.length > 0){
        let arr1 = this.nodesList;
        let arr2 = newValue;
        const mergedArray = Array.from([...arr1, ...arr2].reduce((map, obj) => {
          map.set(obj.id, obj);
          return map;
        }, new Map()).values());
        console.log(mergedArray );
        this.nodesList = mergedArray;
      }
    },
  },
  mounted(){
    this.getUserNodes();
   //当没有默认节点时， 默认选择节点 数据的第一个
    if(!this.isEdit){
      if((!this.$root.curNodeInfo || !this.$root.curNodeInfo.id) && this.$root.nodes.length > 0){
        let nodeIndex = 0;
        if (this.dcsMode) { // 选DCS的节点需过滤没有开启DCS配置的节点
          nodeIndex = this.$root.nodes.findIndex((node) => {
            return this.ApiService.disabledDCSNodeIds.indexOf(node.id) === -1;
          });
        }
        if(this.objInfo.targetNodeId){
          nodeIndex = this.$root.nodes.findIndex((node) => {
            return this.objInfo.targetNodeId === node.id;
          });
        }
        this.objInfo.targetNodeId = this.$root.nodes[nodeIndex].id;
        this.objInfo.targetNodeName = this.$root.nodes[nodeIndex].name;
        this.isDisabled = false;
        // 判断节点实际是否发生改变
        if(nodeIndex > -1){
          this.$emit('changeNode', false);
        }else{
          this.$emit('changeNode', this.$root.nodes[nodeIndex]);
        }
      }else if(this.$root.curNodeInfo && this.$root.curNodeInfo.id && !this.objInfo.targetNodeId){
        this.objInfo.targetNodeId = this.$root.curNodeInfo.id;
        this.objInfo.targetNodeName = this.$root.curNodeInfo.name;
        this.isDisabled = true;
        this.$emit('changeNode');
      }
    }else{
      this.isDisabled = true;
    }
  },
  methods:{
    getUserNodes(){
      let _this = this;
      this.$ajax.get('SyncNode/GetAll').then(function (res) {
        if(res.data.success){
          let result = res.data.data;
          //判断节点是否有权限是否需要禁用
          result.forEach((node) => {
            let index = _this.$root.nodes.findIndex(value => {
              return value.id === node.id
            });
            if(index === -1){
              node.disabled = true;
            }
          });
          // 因为用户模块会根据AC全局同步用户需要回显Location的信息，所有特意加了这个逻辑，为了确保在子节点能正常显示其他节点的信息
          let arr1 = result;
          let arr2 = _this.additionalNode;
          const mergedArray = Array.from([...arr1, ...arr2].reduce((map, obj) => {
            map.set(obj.id, obj);
            return map;
          }, new Map()).values());
          console.log(mergedArray );
          _this.nodesList = mergedArray;
        } 
      });
    },
    changeNode:function(data){
      this.$emit('changeNode',data);
      if(data){
        this.objInfo.targetNodeName = data.label;
      }
    },
  },
}
</script>

<style scoped>
.is-top{
  display: flex;
  justify-content: flex-start;
    
}
.is-top-conntorl{
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/admin/components/commonComponents/utmSelectNode.vue